import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { closeDialog, openDialog } from '../../../dialog/reducer';
import { isDialogOpen } from '../../../dialog/selectors';

const name = 'loyaltyMembershipErrorDialog';

export const useLoyaltyMembershipErrorDialog = () => {
    const dispatch = useCommanderThunkDispatch();

    const handleOpenDialog = () => dispatch(openDialog(name));
    const handleCloseDialog = () => dispatch(closeDialog(name));

    return {
        openDialog: handleOpenDialog,
        closeDialog: handleCloseDialog,
    };
};

export const useLoyaltyMembershipErrorDialogState = () =>
    useCommanderSelector((state) => isDialogOpen(state, { name }));
